import { ContractOrderOutputDto } from '@api/client';
import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'shared/utils/common.utils';
import AssociateExternalCollaboratorsToPassiveInvoiceModal from '../associate-external-collaborators-to-passive-cycle-invoice-modal';
import { useState } from 'react';

interface Props {
  order: ContractOrderOutputDto;
}

const PassiveOrderEconomicsData: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation();
  const [isAssociateExternalCollabModalVisible, setIsAssociateExternalCollabModalVisible] = useState(false);

  if (order) {
    return (
      <div className="table-responsive table-bordered mt-3">
        <Table className={'mt-0 mb-0'}>
          <thead className="bg-red">
            {order.category?.id === 48 ? (
              <tr>
                <th scope="col">
                  <span>{'Supply amount'}</span>
                </th>
                <th scope="col">
                  <span>{'Tot days'}</span>
                </th>
                <th scope="col">
                  <span>{'A. Costs'}</span>
                </th>
                <th scope="col">
                  <span>{'A. M/D'}</span>
                </th>
                <th scope="col">
                  <span>{'F. Costs'}</span>
                </th>
                <th scope="col">
                  <span>{'F. M/D'}</span>
                </th>
                <th scope="col">
                  <span>{'Invoices received'}</span>
                </th>
                <th scope="col">
                  <span>{'FdR'}</span>
                </th>
                <th scope="col">
                  <span>{'Collab'}</span>
                </th>
              </tr>
            ) : (
              <tr>
                <th scope="col">
                  <span>{'Supply amount'}</span>
                </th>
                <th scope="col">
                  <span>{'A. Costs'}</span>
                </th>
                <th scope="col">
                  <span>{'Invoices received'}</span>
                </th>
                <th scope="col">
                  <span>{'FdR'}</span>
                </th>
                <th scope="col">
                  <span>{'Remaining balance'}</span>
                </th>
                <th scope="col">
                  <span>{'Link Doc'}</span>
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            {order.category?.id === 48 ? (
              <tr>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">{formatCurrency(order.contractValue)}€</p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.orderExternalCollaborators
                        ? order.orderExternalCollaborators.reduce((acc, el) => acc + (el.numGiornate || 0), 0)
                        : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPACostiEsterni !== undefined ? `${formatCurrency(order.ordCPACostiEsterni)}€` : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">{order.ordCPAggu !== undefined ? order.ordCPAggu : '-'}</p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPACostiEsterni !== undefined
                        ? `${formatCurrency(order.ordCPResiduoDaFatturare)}€`
                        : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">{order.ordCPResiduoGGu !== undefined ? order.ordCPResiduoGGu : '-'}</p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPTotFattureRicevute !== undefined
                        ? `${formatCurrency(order.ordCPTotFattureRicevute)}€`
                        : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPFdR !== undefined ? `${formatCurrency(order.ordCPFdR)}€` : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-center">
                  <Button
                    className="btn text-blue-links border-none p-0"
                    type="button"
                    variant="icon"
                    onClick={() => setIsAssociateExternalCollabModalVisible(true)}
                  >
                    <i className="icon-eye-shows text-blue-links" />
                  </Button>
                </td>
              </tr>
            ) : (
              <tr>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">{formatCurrency(order.contractValue)}€</p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPACostiEsterni !== undefined ? `${formatCurrency(order.ordCPACostiEsterni)}€` : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPTotFattureRicevute !== undefined
                        ? `${formatCurrency(order.ordCPTotFattureRicevute)}€`
                        : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPFdR !== undefined ? `${formatCurrency(order.ordCPFdR)}€` : '-'}
                    </p>
                  </span>
                </td>
                <td className="text-end">
                  <span className="d-inline-flex align-items-center">
                    <p className="my-auto">
                      {order.ordCPResiduo !== undefined ? `${formatCurrency(order.ordCPResiduo)}€` : '-'}
                    </p>
                  </span>
                </td>
                <td>
                  {order.linkDocumentation ? (
                    <a href={order.linkDocumentation} target="_blank" rel="noreferrer">
                      <i className="icon-noun-link text-blue-links fs-6" />
                    </a>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <AssociateExternalCollaboratorsToPassiveInvoiceModal
          isOpen={isAssociateExternalCollabModalVisible}
          onClose={() => setIsAssociateExternalCollabModalVisible(false)}
          idOrdine={order.id}
        />
      </div>
    );
  } else {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '4rem' }}>
        {t('No order details')}
      </div>
    );
  }
};

export default PassiveOrderEconomicsData;
